import {combineReducers, configureStore} from '@reduxjs/toolkit';
import sessionReducer from './data/session';
import periodsReducer from './data/periods';
import reportsReducer from './data/reports';
import disclosureReviewReducer from './data/disclosureReview';
import documentsReducer from './data/documents';
import copilotReducer from './data/copilot';
import foldersReducer from './data/folders';
import {apiSlice} from './data/api';
import {copilotV2ApiSlice} from './data/copilotV2Api';
import {excelApiSlice} from './data/excelApi';
import {disclosuresApiSlice} from './data/disclosuresApi';
import {documentWorkspaceApiSlice} from './data/documentWorkspaceApi';
import {disclosureReviewApiSlice} from './data/disclosureReviewApi';
import {pdfReviewApiSlice} from './data/pdfReviewApi';
import storage from 'redux-persist/lib/storage';
import {
  persistReducer,
  FLUSH,
  REHYDRATE,
  createTransform,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';

// Reset stale isFetching state in copilot slice for table formatting when rehydrating from localStorage
// If isFetching was true in persisted state, it's stale
const resetFormattingStatusTransform = createTransform(
  (inboundState) => inboundState,
  (outboundState) => {
    if (!outboundState) return outboundState;

    // Ensure tableFormatting exists (backward compatibility)
    if (!outboundState.tableFormatting) {
      return {
        ...outboundState,
        tableFormatting: {
          resultsByDocument: {},
          isFetching: false,
        },
      };
    }

    // Reset stale isFetching state
    return {
      ...outboundState,
      tableFormatting: {
        ...outboundState.tableFormatting,
        isFetching: false,
        showSnackbar: false,
      },
    };
  },
  {whitelist: ['copilot']}
);

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['copilot', 'disclosureReview'],
  transforms: [resetFormattingStatusTransform],
};

export const rootReducers = combineReducers({
  copilot: copilotReducer,
  periods: periodsReducer,
  reports: reportsReducer,
  disclosureReview: disclosureReviewReducer,
  documents: documentsReducer,
  session: sessionReducer,
  folders: foldersReducer,
  [apiSlice.reducerPath]: apiSlice.reducer,
  [copilotV2ApiSlice.reducerPath]: copilotV2ApiSlice.reducer,
  [excelApiSlice.reducerPath]: excelApiSlice.reducer,
  [disclosureReviewApiSlice.reducerPath]: disclosureReviewApiSlice.reducer,
  [disclosuresApiSlice.reducerPath]: disclosuresApiSlice.reducer,
  [documentWorkspaceApiSlice.reducerPath]: documentWorkspaceApiSlice.reducer,
  [pdfReviewApiSlice.reducerPath]: pdfReviewApiSlice.reducer,
});
const persistedReducer = persistReducer(persistConfig, rootReducers);

export default configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(
      apiSlice.middleware,
      copilotV2ApiSlice.middleware,
      excelApiSlice.middleware,
      disclosureReviewApiSlice.middleware,
      disclosuresApiSlice.middleware,
      documentWorkspaceApiSlice.middleware,
      pdfReviewApiSlice.middleware
    ),
});
